export default __webpack_public_path__ + "static/media/Clouds_1.0706ba36.svg";